import { UITheme } from "./ui.types";

export type ComponentWithTheme = {
  theme?: UITheme;
};

export type AuthTokens = {
  accessToken: string;
  refreshToken: string;
};

export enum PostHogEvent {
  SIGN_UP = "user_signed_up",
  PERSONAL_DETAILS_SUBMITTED = "personal_details_submitted",
  PHOTO_VERIFIED = "photo_verified",
  DESCRIPTION_ADDED = "description_added",
}
